import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import defaultPicture from '@app/assets/defaultProjectPicture.png'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { Image } from '@app/components/core/image/Image'
import { expandImage, type StoredImage } from '@app/types/StoredImage'

export type UserInitiativeCardProps = {
  id: number
  slug?: string
  title: string
  image?: string | StoredImage
  subTitle?: string
}

export const UserInitiativeCard = ({
  id,
  slug,
  title,
  image,
  subTitle,
}: UserInitiativeCardProps) => {
  const [_, navigate] = useLocation()
  const { src, altText } = expandImage(image, title ? `${title} image` : '')
  return (
    <Row
      onClick={() => navigate(pages.initiative(slug ?? id.toString()))}
      gap="0.625rem"
      style={{
        width: '100%',
        padding: '0.5rem',
        alignItems: 'center',
        borderRadius: '0.625rem',
        border: 'var(--border-subtle)',
        background: 'var(--palette-white)',
        cursor: 'pointer',
      }}
    >
      <Image
        src={src || defaultPicture}
        resizeWidth={40}
        alt={altText}
        style={{
          width: '2.5rem',
          height: '2.5rem',
          display: 'block',
          borderRadius: '0.4rem',
          aspectRatio: '1/1',
        }}
      />
      <Column gap="0.25rem">
        <Text.Medium isBold={true} style={{ textOverflow: 'ellipsis' }}>
          {title}
        </Text.Medium>
        <Text.ExtraSmall>{subTitle}</Text.ExtraSmall>
      </Column>
    </Row>
  )
}
